module.exports = __webpack_public_path__ + "img/egresso-coautoria-orientador.f66e0353.png";